import Api from '../Api';

export const getDepartmentTrackingOfJobchart = id => async dispatch => {
  try {
    const { data } = await Api.get(`/issuereceive/departmenttracking/${id}`);
    dispatch({
      type: 'FETCH_DEPARTMENT_TRACKING_OF_JOBCHART',
      payload: data,
    });
  } catch (error) {
    console.error(error);
  }
};

export const clearDepartmentTrackingOfJobchart = () => {
  return {
    type: 'CLEAR_DEPARTMENT_TRACKING_OF_JOBCHART',
  };
};

export const getOldDepartmentTrackingOfJobchart = id => async dispatch => {
  try {
    const { data } = await Api.get(
      `/issuereceive/departmenttracking/old/${id}`
    );
    dispatch({
      type: 'FETCH_OLD_DEPARTMENT_TRACKING_OF_JOBCHART',
      payload: data,
    });
  } catch (error) {
    console.error(error);
  }
};

export const clearOldDepartmentTrackingOfJobchart = () => {
  return {
    type: 'CLEAR_OLD_DEPARTMENT_TRACKING_OF_JOBCHART',
  };
};

export const getCurrentDepartmentInfoForJobchart =
  (id, process, factoryId) => async dispatch => {
    try {
      const { data } = await Api.get(
        `/issuereceive/departmenttracking/${id}/${process}/${factoryId}`
      );
      dispatch({
        type: 'FETCH_CURRENT_DEPARTMENT_INFO_FOR_JOBCHART',
        payload: data,
      });
    } catch (error) {
      console.error(error);
    }
  };

export const clearCurrentDepartmentInfoForJobchart = () => {
  return {
    type: 'CLEAR_CURRENT_DEPARTMENT_INFO_FOR_JOBCHART',
  };
};

export const getIssueChallans = query => async dispatch => {
  try {
    const { data } = await Api.get(`/issuereceive/challans`, query);
    dispatch({
      type: 'FETCH_ISSUE_CHALLANS',
      payload: data,
    });
  } catch (error) {
    console.error(error);
  }
};

export const clearIssueChallans = () => {
  return {
    type: 'CLEAR_ISSUE_CHALLANS',
  };
};

export const getIssuedItemsOfJobchart = jobchartId => async dispatch => {
  try {
    const { data } = await Api.get(`/issuereceive/items/${jobchartId}`);

    dispatch({
      type: 'FETCH_ISSUED_ITEMS_OF_JOBCHART',
      payload: data,
    });
  } catch (error) {
    console.error(error);
  }
};

export const clearIssuedItemsOfJobchart = () => {
  return {
    type: 'CLEAR_ISSUED_ITEMS_OF_JOBCHART',
  };
};
